export const LoadingSpinner = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g className="animate-spinner-ios origin-center">
      <path d="M10 2.5V5" stroke="#3C3C43" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M13.54 4.7L11.77 6.47" stroke="#3C3C43" strokeOpacity="0.1" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M15 10H17.5" stroke="#C5C5C7" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M13.54 13.54L11.77 11.77" stroke="#C5C5C7" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M10 15V17.5" stroke="#636369" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M6.46 13.54L4.69 15.31" stroke="#636369" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M5 10H2.5" stroke="#3C3C43" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M6.46 6.46L4.69 4.69" stroke="#3C3C43" strokeWidth="1.6" strokeLinecap="round" />
    </g>
  </svg>
);
